import React, {useState, useEffect} from 'react'
import firebase from '../../../config/fbConfig';
import './statistics.css'
import goBackPic from './../../assets/back.png'
import BestRest from './statisticsOptions/bestRest';
import restaurantList from './../../restaurants/restaurantsList'
import BestProduct from './statisticsOptions/bestProduct'
import BestClient from './statisticsOptions/bestClients'
import TotalIncome from './statisticsOptions/totalIncome';

const db = firebase.firestore(); 

function Statistics() {

    const [chosenAction, setChosenAction] = useState({optionNum: 0, name: ""})
    const [statistics, setStatistics] = useState({bestProduct: null, bestRest: null, bestBuyer: null, totalMoney: null})
    useEffect(() => {
        db.collection('statistics').doc('orders').get().then((doc) => {
            let allStatistics = doc.data().orders;
            let bestProduct = [];
            let bestRest = [];
            let bestBuyer = [];
            let totalMoney = [];
            for (let i=0; i< allStatistics.length; i++) {
                bestProduct.push({
                    timestamp: allStatistics[i].timestamp,
                    bestProduct: allStatistics[i].bestProduct
                });
                bestRest.push({
                    timestamp: allStatistics[i].timestamp,
                    bestRest: allStatistics[i].bestRest
                });
                bestBuyer.push({
                    timestamp: allStatistics[i].timestamp,
                    bestBuyer: allStatistics[i].bestBuyer
                });
                totalMoney.push({
                    timestamp: allStatistics[i].timestamp,
                    totalMoney: allStatistics[i].totalMoney
                })
            }
            setStatistics({bestProduct, bestRest, bestBuyer, totalMoney})
        });
        
    }, [])
    
    let getDateFormat = (timestamp) => {
        return `${new Date(timestamp*1000).toLocaleDateString("en-GB")}`;
    }

    // To add another checkpoint in statistics
    let resetStatistics = () => {
        if (window.location.href.includes('/en')) {
            if (!window.confirm("Are you sure you want to 𝗦𝗘𝗧 𝗧𝗛𝗜𝗦 𝗖𝗛𝗘𝗖𝗞𝗣𝗢𝗜𝗡𝗧?")) return;
        } else {
            if (!window.confirm("האם אתה בטוח שברצונך ליצור צ'קפוינט חדש?")) return;
        }
        
        let bestRest = [];
        for (let i = 0; i<restaurantList.length; i++) {
            bestRest.push({
                name: restaurantList[i].title,
                counter: 0
            });			
        } 

        let timestamp = firebase.firestore.Timestamp.fromDate(new Date()).seconds;
        let deliveredInfo = {
            bestProduct: [],
            bestRest: bestRest,
            bestBuyer: [],
            timestamp: timestamp,
            totalMoney: 0
        }

        db.collection('statistics').doc('orders').update({
            orders: firebase.firestore.FieldValue.arrayUnion(deliveredInfo)
        });
        alert(`Checkpoint successfully added as ${getDateFormat(timestamp)}`)
    }

if (window.location.href.includes('/en')) {
    return (
        <div id="statistics">
            
            {chosenAction.optionNum == 0 ? <div className="titleComponent">Statistics<br/>More can be found in Google Analytics page</div> : <div className="titleComponent">{chosenAction.name}</div>}
            {chosenAction.optionNum == 0 &&
                <React.Fragment>
                
                <div id="statisticsOptions">
                    <button onClick={resetStatistics}>Click here to set checkpoint to current date</button>
                    <button data-chosen="1" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>Best Selling Restaurant</button>
                    <button data-chosen="2" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>Best Clients</button>
                    <button data-chosen="3" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>Most Sold Items</button>
                    <button data-chosen="4" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>Total Income €€€</button>
                </div>
                </React.Fragment>
            }
            {chosenAction.optionNum != 0 && 
            <div id="filteredOption">
                <img src={goBackPic} id="goBackPic" onClick={() => setChosenAction({optionNum: 0})}/>
                {chosenAction.optionNum == 1 && <BestRest getDateFormat={getDateFormat} statistics={statistics.bestRest} />}
                {chosenAction.optionNum == 2 && <BestClient getDateFormat={getDateFormat} statistics={statistics.bestBuyer}/>}
                {chosenAction.optionNum == 3 && <BestProduct getDateFormat={getDateFormat} statistics={statistics.bestProduct}/>}
                {chosenAction.optionNum == 4 && <TotalIncome getDateFormat={getDateFormat} statistics={statistics.totalMoney}/>}
            </div>
            }

        </div>
    )
}
// Else render it in Hebrew
    return (
        <div id="statistics">
            
            {chosenAction.optionNum == 0 ? <div className="titleComponent">סטטיסטיקות<br/>מידע נוסף נמצא באתר Google Analaytics</div> : <div className="titleComponent">{chosenAction.name}</div>}
            {chosenAction.optionNum == 0 &&
                <React.Fragment>
                
                <div id="statisticsOptions">
                    <button onClick={resetStatistics}>לחץ כאן כדי ליצור צ'קפוינט חדש לתאריך הנוכחי</button>
                    <button data-chosen="1" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>המסעדה המניבה ביותר</button>
                    <button data-chosen="2" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>הקליינטים הטובים ביותר</button>
                    <button data-chosen="3" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>המוצרים הכי נמכרים</button>
                    <button data-chosen="4" onClick={(e) => setChosenAction({optionNum: e.target.dataset.chosen, name: e.target.innerHTML})}>הכנסה כללית €€€</button>
                </div>
                </React.Fragment>
            }
            {chosenAction.optionNum != 0 && 
            <div id="filteredOption">
                <img src={goBackPic} id="goBackPic" onClick={() => setChosenAction({optionNum: 0})}/>
                {chosenAction.optionNum == 1 && <BestRest getDateFormat={getDateFormat} statistics={statistics.bestRest} />}
                {chosenAction.optionNum == 2 && <BestClient getDateFormat={getDateFormat} statistics={statistics.bestBuyer}/>}
                {chosenAction.optionNum == 3 && <BestProduct getDateFormat={getDateFormat} statistics={statistics.bestProduct}/>}
                {chosenAction.optionNum == 4 && <TotalIncome getDateFormat={getDateFormat} statistics={statistics.totalMoney}/>}
            </div>
            }

        </div> 
    )
}

export default Statistics
